import { Modal, Form, Input, Select } from 'antd';
import { usePostProjectAccessMutation } from '../features/api/apiSlice';

export default function AccessInvite(props) {
  const { open, setOpen, form, projectId } = props;
  const [postProjectAccess, { isLoading }] = usePostProjectAccessMutation();

  const handleInvite = () => {
    form
      .validateFields()
      .then(async (values) => {
        const { role, phone, email } = values;
        await postProjectAccess({ projectId, role, phone, email }).unwrap();
        setOpen(false);
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  return (
    <Modal
      open={open}
      title="Invite User"
      okText="Send Invite"
      cancelText="Cancel"
      centered
      onCancel={() => {
        form.resetFields();
        setOpen(false);
      }}
      onOk={handleInvite}
      okButtonProps={{ loading: isLoading }}
      styles={{
        header: { padding: '20px 24px 0', marginBottom: 0 },
        body: { padding: '16px 24px 8px' },
        footer: { padding: '8px 24px 20px' },
      }}
    >
      <Form form={form} layout="vertical" style={{ marginTop: 8 }}>
        <Form.Item
          name="role"
          label="Role"
          rules={[{ required: true, message: 'Please select a role' }]}
        >
          <Select placeholder="Please select role" size="large">
            <Select.Option value="ProjectManager">Project Manager</Select.Option>
            <Select.Option value="SiteEngineer">Site Engineer</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Please enter an email' },
            { type: 'email', message: 'Please enter a valid email' },
          ]}
        >
          <Input placeholder="user@example.com" size="large" />
        </Form.Item>
        <Form.Item name="phone" label="Phone">
          <Input placeholder="+31 6 1234 5678" size="large" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
